import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=7f9c2753&scoped=true&v-if=isAuthorized&"
import script from "./Comments.vue?vue&type=script&lang=js&"
export * from "./Comments.vue?vue&type=script&lang=js&"
import style0 from "./Comments.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Comments.vue?vue&type=style&index=1&id=7f9c2753&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9c2753",
  null
  
)

export default component.exports